import { assetSideMenuSize } from '../../../consts';
import { GalleryAccessLevel } from '../../../lib/access-level';

export const feedbackButtonSizes: { [propName: string]: { small: number; full: number } } = {
  favourite: { small: 60, full: 60 },
  status: { small: 62, full: 185 },
  ['display-status']: { small: 62, full: 185 },
  color_label: { small: 62, full: 130 },
  comment: { small: 40, full: 135 },
  annotation: { small: 40, full: 82 },
};

const getTotalDisplaySize = (
  display: { [propName: string]: 'full' | 'small' },
  disabledFeedbackItems: { icon: string; option: string; name: string }[],
  accessLevel: GalleryAccessLevel
) => {
  const spacing = 6; // gap between buttons
  let total = accessLevel === 'edit' ? 40 : 0;
  for (const key in display) {
    const k = key;
    total += feedbackButtonSizes[k][display[key]];
    total += spacing;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  for (const item of disabledFeedbackItems) {
    if (['color_label', 'status'].includes(item.option)) {
      total += 62 + spacing;
    } else {
      total += 40 + spacing;
    }
  }
  return total - spacing;
};

export const fits = (
  display: { [propName: string]: 'full' | 'small' },
  disabledFeedbackItems: { icon: string; option: string; name: string }[],
  sidebarOpen: boolean,
  accessLevel: GalleryAccessLevel
) => {
  const width = getTotalDisplaySize(display, disabledFeedbackItems, accessLevel);
  return width < window.innerWidth - 20 - (sidebarOpen ? assetSideMenuSize : 0);
};
